import React, { useState, useEffect } from "react";
import "./menu.css";
import kebab from "./kebab.jpg";
import Sandwish from "./MenuItems/sandwish";
import Burger from "./MenuItems/burger";
import Pizza from "./MenuItems/pizza";
import Assietes from "./MenuItems/assietes";
import Texmex from "./MenuItems/texmex";
import Salade from "./MenuItems/salade";
import Dessert from "./MenuItems/dessert";
import Soda from "./MenuItems/soda";
import Pasta from "./MenuItems/pasta";
import Kids from "./MenuItems/kids";
import Tacos from "./MenuItems/tacos";
import Aos from "aos";
import "aos/dist/aos.css";

function Menu() {
  const [active, setActive] = React.useState("pizza");
  React.useEffect(() => {
    Aos.init();
  }, []);

  const setColor = (active) => {
    if (active == "pizza") {
      return "green";
    } else {
      return "yellow";
    }
  };
  return (
    <>
      <div className="temoignage-head" id="menu">
        <span> Choisissez en fonction du bouton </span>
        <h1> Notre Menu ⭐ </h1>
      </div>
      <div className="but" data-aos="zoom-in" data-aos-duration="1500">
        <button
          className={`tag  ${setColor(active)}   `}
          onClick={() => setActive("pizza")}
        >
          🍕{" "}
        </button>

        <button onClick={() => setActive("burger")}>🍔</button>
        <button onClick={() => setActive("salade")}>🥗</button>
        <button onClick={() => setActive("tacos")}>🌯 </button>
        <button onClick={() => setActive("sandwish")}>🥪 </button>
        <button onClick={() => setActive("pasta")}>🍝 </button>
        <button onClick={() => setActive("texmex")}>🍗</button>
        <button onClick={() => setActive("assietes")}>🍲</button>
        <button onClick={() => setActive("kids")}>👶🥖 </button>
        <button onClick={() => setActive("dessert")}>🍰 </button>
        <button onClick={() => setActive("soda")}>🥤 </button>
      </div>

      {active == "pizza" && <Pizza />}
      {active == "burger" && <Burger />}
      {active == "sandwish" && <Sandwish />}
      {active == "assietes" && <Assietes />}
      {active == "soda" && <Soda />}
      {active == "texmex" && <Texmex />}
      {active == "salade" && <Salade />}
      {active == "pasta" && <Pasta />}
      {active == "dessert" && <Dessert />}
      {active == "kids" && <Kids />}
      {active == "tacos" && <Tacos />}
    </>
  );
}

export default Menu;
